import React from 'react'
import AccordionSecondary from './../../../components/accordion/accordion-secondary.component'
import BalanceAfterPurchase from './balance-after-purchase.component'
import PaymentInfoContent from './payment-info-content.component'
import RedeemButton from './redeem-button.component'
import StyledFlexContainer from './../../../components/containers/flex-container.component'
import { StyledContainer } from './styled-components'
import { UserService } from './../../../services/user.service'
import Button from '../../../components/buttons/buttons.component'

const buttonContainerStyle = {
	alignSelf: 'center',
	display: 'flex',
	justifyContent: 'flex-end',
}

class PaymentInfo extends React.Component {
	constructor(props) {
		super(props)
		this.getAccordionItems = getAccordionItems.bind(this)

		this.state = {
			role: null,
			selectedCondition: 0,
		}
	}

	componentWillReceiveProps(nextProps) {
		if (
			nextProps.paymentConditions.length !=
			this.props.paymentConditions.length
		) {
			const selectedCondition = nextProps.paymentConditions
				.map((item, index) => ((item.index = index), item))
				// .find(
				// 	({ order, forSubscribers }) => !forSubscribers && order === 1
				// ).index
				.find(({ order, forSubscribers }) => !forSubscribers).index

			this.setState({ selectedCondition })
		}
	}

	async componentDidMount() {
		const { user } = this.props
		const notAuthenticated = user === null

		if (notAuthenticated) return

		const role = await UserService.getMostImportantRole(user.roles)
		this.setState({ role })
	}

	render() {
		const { user, client, className, productId, paymentConditions } =
			this.props
		const { role, selectedCondition } = this.state
		const paymentCondition = paymentConditions[selectedCondition]

		return (
			<StyledContainer className={className}>
				<AccordionSecondary
					arrow={false}
					multiple={false}
					noClickable
					noAnimated
					items={this.getAccordionItems()}
				/>
				<StyledFlexContainer marginTop={0.2}>
					<div className={'col-6'}>
						<BalanceAfterPurchase
							role={role}
							user={user}
							client={client}
							paymentCondition={paymentCondition}
						/>
					</div>

					<div style={buttonContainerStyle} className={'col-6'}>
						<RedeemButton
							role={role}
							user={user}
							client={client}
							productId={productId}
							paymentCondition={paymentCondition}
						/>
					</div>
				</StyledFlexContainer>
			</StyledContainer>
		)
	}
}

function getAccordionItems() {
	const { productId, paymentConditions, productName, user } = this.props
	const { selectedCondition } = this.state

	return [
		{
			title: productName,
			content: (
				<PaymentInfoContent
					user={user}
					productId={productId}
					paymentConditions={paymentConditions}
					selectedCondition={selectedCondition}
					onPaymentSelected={(selectedCondition) =>
						this.setState({ selectedCondition })
					}
				/>
			),
		},
	]
}

export default PaymentInfo
